import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useDashboard } from "../context/DashboardContext";

export function useDashData(path, { withDates = true, extra = {}, enabled = true } = {}) {
  const { branchId, range } = useDashboard();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const extraKey = JSON.stringify(extra);

  const load = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    try {
      const params = { branch_id: branchId, ...extra };
      if (withDates) { params.start = range.start; params.end = range.end; }
      const res = await api.get(path, { params });
      setData(res.data);
    } catch (e) {
      // keep previous data
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, branchId, range.start, range.end, extraKey, withDates, enabled]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const h = () => load();
    window.addEventListener("dash-refresh", h);
    return () => window.removeEventListener("dash-refresh", h);
  }, [load]);

  return { data, loading, reload: load };
}
